import {
  Component,
  Output,
  Input,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { TimelineComponent } from '../../timeline/timeline.component';
import { TagsService } from '../../../core/services/tags/tags.service';
import { AlertService } from '../../../core/services/alert/alert.service';
@Component({
  selector: 'app-form-add-tags',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    TimelineComponent,
  ],
  templateUrl: './form-add-tags.component.html',
  styleUrl: './form-add-tags.component.css',
})
export class FormAddTagsComponent {
  @ViewChild('requireActionCheckbox') requireActionCheckbox!: ElementRef;
  @Output() backButtonClick = new EventEmitter<boolean>();
  @Output() addTags = new EventEmitter<boolean>();
  @Input() tagsData?: any;
  form: FormGroup;
  arrayConditions: any = [{ condition: '', operator: '', value: '' }];
  arrayActions: any = [{ action: '', value: '' }];
  enabled = true;
  opt = 'new';

  entities: string[] = ['order'];

  btnEnable = false;
  constructor(
    private fb: FormBuilder,
    private tagsService: TagsService,
    private alertService: AlertService,
    private location: Location
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      hex: ['#000000', Validators.required],
    });
  }

  onColorPickerChange(event: any) {
    const color = event.target.value;
    this.form.get('hex')?.setValue(color);
  }

  onHexInputChange(event: any) {
    const hex = event.target.value;
    this.form.get('hex')?.setValue(hex);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tagsData']) {
      if (this.tagsData) {
        this.btnEnable = true;
        this.opt = 'update';
        this.form.patchValue({
          name: this.tagsData.name,
          hex: this.tagsData.hex,
        });
      }
    }
  }

  ngAfterViewInit() {
    this.requireActionCheckbox.nativeElement.checked = true;
  }

  addCondition() {
    if (this.arrayConditions == null) {
      this.arrayConditions = [{ condition: '', operator: '', value: '' }];
    } else {
      this.arrayConditions.push({ condition: '', operator: '', value: '' });
    }
  }

  removeCondition(index: number) {
    this.arrayConditions.splice(index, 1);
  }

  updateCondition(index: number, field: string, event: Event): void {
    const value = (event.target as HTMLInputElement | HTMLSelectElement).value;
    this.arrayConditions[index][field] = value;
  }

  addAction() {
    this.arrayActions.push({ action: '', value: '' });
  }

  removeAction(index: number) {
    this.arrayActions.splice(index, 1);
  }

  updateAction(index: number, field: string, event: any) {
    this.arrayActions[index][field] = event.target.value;
  }

  emitBackButtonClick() {
    const nuevaURL = this.location.path();
    const index = nuevaURL.indexOf('/');
    this.location.go(nuevaURL.substring(0, index) + '/settings/tags');
    this.form.patchValue({
      name: '',
      description: '',
      event_id: '',
    });

    this.arrayConditions = [{ condition: '', operator: '', value: '' }];
    this.arrayActions = [{ action: '', value: '' }];
    this.backButtonClick.emit(true);
  }

  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.enabled = true;
    } else {
      this.enabled = false;
    }
  }

  emitAddAuto() {
    this.opt = 'new';
    this.addTags.emit(true);
  }

  onSubmit() {
    let formResult = this.form.value;
    formResult.entity = 'order';
    this.alertService.loading('swal_messages.adding_tags');
    this.tagsService.createTag(formResult).subscribe({
      next: (data) => {
        this.alertService
          .successOk('swal_messages.tags_added')
          .then((result) => {
            if (result.isConfirmed) {
              this.emitAddAuto();
            }
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  //onSubmitOrder(): void {};
  onSubmitOrder(): void {
    let formResult = this.form.value;
    this.alertService.loading('swal_messages.tags.updating_tags');
    this.tagsService
      .updateData(this.tagsData.reference, formResult)
      .subscribe({
        next: (result: any) => {
          this.alertService
            .successOk('swal_messages.tags.tags_updated')
            .then((result) => {
              if (result.isConfirmed) {
                this.form.reset();
                this.emitAddAuto();
                this.emitBackButtonClick();
              }
            });
        },
        error: (error: any) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
            }
          });
        },
      });
  }
}
